import { StatusCode } from "api/protocols";
import { GetRainChecks, IRainCheck } from "api/rpc/2024-04/facilityAdmin/payment/rainCheck";
import Callout from "components/callout/Callout";
import Input from "components/form/input/Input";
import MessageDisplay from "components/messageDisplay/MessageDisplay";
import Sheet from "components/sheet/Sheet";
import Tabs from "components/tabs/Tabs";
import { LocaleCurrency } from "helpers/Locale";
import { useAppDispatch } from "hooks/redux";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { showError } from "redux/actions/ui";
import { ICart } from "redux/reducers/models/cart";

interface IProps {
  open: boolean;
  onOk: (code: string, id: number) => void;
  onCancel: () => void;
  cart: ICart;
}

interface ISelectedRainChecks
{
    rainChecks: Array<IRainCheck>,
    selectedRainCheck: number,
}

export default function RainCheckRedeem(props: IProps) {
  const [selected, setSelected] = useState(0);
  const { open, onOk, onCancel, cart } = props;
  const { t } = useTranslation();
  const [redeemRainCheck, setStateRainCheckCode] = useState("");
  const [rainChecks, setRainChecks] = useState <ISelectedRainChecks> ({
    rainChecks: [],
    selectedRainCheck: null,
  });
  const dispatch = useAppDispatch();

  async function getRainChecks() {
    const res = await GetRainChecks({ customer_id: cart?.customer_id }, true);

    if (res?.status !== StatusCode.OK) {
      dispatch(showError("Response was not sucessfull"));
      return;
    }

    setRainChecks({ rainChecks: res.data, selectedRainCheck: null });
  }

  function handleOnOk() {

      void onOk(redeemRainCheck, rainChecks.selectedRainCheck);
  }

  function clearSelection() {
    // Clear both the selected rain check from the list and the manual code input
    setRainChecks(prev => ({ ...prev, selectedRainCheck: null }));
    setStateRainCheckCode("");
  }

  function handleTabSelect(tabIndex: number) {
    setSelected(tabIndex);
    clearSelection();
  }

  console.log(rainChecks);

  useEffect(() => {
    if (props.open) {
      if (cart?.customer_id) {
        void getRainChecks();
      }
      setSelected(0);
    } else {
      setRainChecks({ rainChecks: [], selectedRainCheck: null });
    }
  }, [props.open]);

  const tabs = [
    {
      content: t("Customer Rain Checks"),
    },
    {
      content: t("Enter Rain Check Code"),
    },
  ];

  // Determine if OK button should be enabled
  const isOkEnabled = cart && (
    (selected === 0 && rainChecks.selectedRainCheck !== null) ||
    (selected === 1 && redeemRainCheck.trim() !== "")
  );

  return (
    <Sheet
      open={open}
      size="small"
      onCancel={onCancel}
      onOk={handleOnOk}
      closable
      title={t("Rain Checks")}
      okDisabled={!isOkEnabled}
    >
      {cart?.id ? (
        <>
          <Tabs tabs={tabs} selected={selected} onSelect={handleTabSelect}>

            {selected === 0 ? (
              <div>
                
                {rainChecks.rainChecks.filter((rainChecks: IRainCheck) => rainChecks.status === "valid").length === 0 ? <div className="pt-2"><MessageDisplay icon={"circle-exclamation"} title={t("No Rain Checks Available")} content={t("This customer does not have any rain checks")} /></div> : rainChecks.rainChecks.filter((rainChecks: IRainCheck) => rainChecks.status === "valid").map((rainCheck: IRainCheck) => (
                  <div
                    key={rainCheck.id}
                    className={
                      rainCheck.id === rainChecks?.selectedRainCheck
                        ? "customer-selected-gift-card"
                        : "customer-gift-card-container"
                    }
                    onClick={() =>
                      setRainChecks(prev => ({
                        ...prev,
                        selectedRainCheck: rainCheck.id,
                      }))
                    }
                  >
                    <p>
                      <strong>Last 4 digits:</strong> {rainCheck.last4}
                    </p>
                    <p>
                      <strong>Balance:</strong>{" "}
                      <LocaleCurrency
                        currency={rainCheck?.currency}
                        amount={rainCheck.balance}
                      />
                    </p>
                  </div>
                ))}
              </div>
            ) : selected === 1 ? (
              <div>
                <Input
                  value={redeemRainCheck}
                  id="redeemRainCheckCode"
                  placeholder={t("Rain Check Code")}
                  onChange={e => setStateRainCheckCode(e.target.value)}
                  autoFocus
                />
              </div>
            ) : null}
          </Tabs>
        </>
      ) : (
        <Callout
          title={t("secure.facility.tee_sheet.tee_sheet_booking_details.093")}
          content={t("secure.facility.tee_sheet.tee_sheet_booking_details.094")}
          type="info"
        />
      )}
    </Sheet>
  );
}